
// ==============================
// PROJECT CONSTANTS
// ==============================

//  to the max value of the category to hide the column or not
export const PERCENTAGE_TO_HIDE = 0.01;

export const AYLA_ALLOWED_ROLES = ['Ayla::Admin', 'Ayla::Staff', 'Ayla::BusinessUser'];

export const ALL_ALLOWED_ROLES = ['Ayla::Admin', 'Ayla::Staff', 'Ayla::BusinessUser', 'OEM::Admin', 'OEM::Staff'];

export const ANALYTICS_WRITE_ROLES = ['Ayla::Admin', 'OEM::Admin'];

export const ONE_TIME_REPORTS = ['Get_List_Of_Oems'];

export const EMPTY_OBJ = {
};

export const DSNS_DROPDOWN_VALUES = {
  'All': 'All',
};

export const REGIONS = {
  // eslint-disable-next-line quote-props
  'EU': 'EU-FIELD',
  'US-FIELD': 'US-FIELD',
};

export const REGIONS_FOR_VPC = {
  // eslint-disable-next-line quote-props
  'US-VPC': 'US-VPC',
};

export const REGIONS_FOR_EU = {
  // eslint-disable-next-line quote-props
  'EU': 'EU-FIELD',
};

export const REGIONS_FOR_US = {
  // eslint-disable-next-line quote-props
  'US-FIELD': 'US-FIELD',
};

export const DURATION = [{values: ['Monthly', 'Quarterly']}];

export const MONTH_NAME = {
  '1': 'January',
  '2': 'February',
  '3': "March",
  '4': "April",
  '5': "May",
  '6': "June",
  '7': "July",
  '8': "August",
  '9': "September",
  '10': "October",
  '11': "November",
  '12': "December"
};

export const QUARTER_NAME = {
  "1": "Quarter 1",
  "2": "Quarter 2",
  "3": "Quarter 3",
  "4": "Quarter 4"
};

// ==============================
// GENERIC CONSTANTS
// ==============================
export const REPORT_DESCRIPTION_WIDTH = 0.05;
export const DEFAULT_TABLE_ROWS = 50;
export const LOADER_SMALL = 15;

// ==============================
// ACTION CONSTANTS
// ==============================

const ActionConstants = {
  ADD_REPORTS: 'ADD_REPORTS',
  DECREMENT_FETCH: 'DECREMENT_FETCH',
  FETCH_FILTERS: 'FETCH_FILTERS',
  FETCH_REPORTS: 'FETCH_REPORTS',
  HIDE_ERRORS: 'HIDE_ERRORS',
  INCREMENT_FETCH: 'INCREMENT_FETCH',
  LOG_IN: 'LOG_IN',
  LOG_OUT: 'LOG_OUT',
  RESET_FETCH: 'RESET_FETCH',
  SHOW_ERROR: 'SHOW_ERROR',
  SHOW_LOGIN_ERROR: 'SHOW_LOGIN_ERROR',
  TOGGLE_LOADING: 'TOGGLE_LOADING',
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
};
export const GoogleAnalyticsConstants = {
  BillingReportsPage: {
    title: 'Billing Reports',
  },
  DatapointAnalysisPage: {
    title: 'Datapoint Analysis',
  },
  DatapointTransmissionTrendsPage: {
    title: 'Datapoint Transmission Trends',
  },
  DeviceDetailsPage: {
    title: 'Device Details',
  },
  DeviceSWAnalysisPage: {
    title: 'Device Software Analysis',
  },
  DeviceTrendsPage: {
    title: 'Device Trends',
  },
  DeviceUsageAnalysisPage: {
    title: 'Device Usage Analysis',
  },
  MeteredUsage: {
    title: 'Metered Usage',
  },
  Metering: {
    title: 'Metering',
  },
  NotificationAnalysisPage: {
    title: 'Notification Analysis',
  },
  OnboardingAnalysisPage: {
    title: 'Onboarding Analysis',
  },
  OverviewPage: {
    title: 'Overview',
  },
  UserAnalysisPage: {
    title: 'User Analysis',
  },

};
export default ActionConstants;
